var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 6.25033C4.16667 7.10439 4.68119 7.83708 5.41667 8.15869V1.66699H7.08333V8.15869C7.81881 7.83708 8.33333 7.10439 8.33333 6.25033V1.66699H10V6.25033C10 8.03487 8.75317 9.52682 7.08333 9.90591V18.3337H5.41667V9.90591C3.74683 9.52682 2.5 8.03487 2.5 6.25033V1.66699H4.16667V6.25033ZM13.3333 1.66699C15.6345 1.66699 17.5 3.53248 17.5 5.83366V13.3337H14.1667V18.3337H12.5V1.66699H13.3333Z",
    fill: "#F57E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.aa1cdfe0e21045a452b4aa03114b2af0.svg";
export { ForwardRef as ReactComponent };